import { Fragment, useCallback, useEffect, useState, useContext, useRef } from "react";

//Context
import { AuthContext } from "../../../../common/middlewares/Auth";

//Librerias
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import axios from "axios";

//Hooks
import { useGetHistoricalSurvey } from "../Hooks/useGetHistoricalSurvey";

//Componentes de Material UI
import {
    Typography,
    Box,
    Grid,
    Paper,
    LinearProgress,
    createStyles,
    useTheme,
    Alert,
    AlertTitle,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import Loader from "../../../../common/components/Loader";
import PaperVoluntaria from "../Components/PaperVoluntaria";
import PaperNoVoluntaria from "../Components/PaperNoVoluntaria";
import { format, parseISO } from "date-fns";


const styles = createStyles((theme) => ({
    containerPR: {
        [theme.breakpoints.down("sm")]: {
            paddingRigth: "0px",
            paddingLeft: "0px",
        },
    },
    linearProgress: {
        position: "absolute",
        width: "100%",
        borderRadius: "10px 10px 0 0",
        padding: 0,
    },
    container: {
        position: "relative",
        display: "flex",
    },
    item: {
        flex: 1,
        position: "relative",
    },
    link: {
        display: "flex",
        alignItems: "center",
    },
}));

const CUEncuestaRetiro = ({ changePag, setBtEncuestaActiva, isPreview, values, handleOpenDialog, isTable, isActive }) => {
    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================
    const { guardaCambiosDeLaInformacion, token, strInfoUser, handlerChangeData } = useContext(AuthContext);

    //===============================================================================================================================================
    //========================================== Declaracion de estados =============================================================================
    //===============================================================================================================================================
    const [data, setData] = useState({
        objEncuestaRetiro: null,
    });
    const [loading, setLoading] = useState(false);
    const [flagSubmit, setFlagSubmit] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [loadingGetData, setLoadingGetData] = useState(false);
    const [error, setErrors] = useState({
        flag: false,
        msg: undefined,
    });
    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const handlerChangeDataRef = useRef(handlerChangeData)
    const theme = useTheme()
    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
        clearErrors,
    } = useForm({ mode: "onChange" });

    const { getUniqueData } = useGetHistoricalSurvey();
    const refGetInfoEducacion = useRef(getUniqueData);

    //===============================================================================================================================================
    //========================================== Funciones ==========================================================================================
    //===============================================================================================================================================
    const onSubmit = (data) => {
        setData((prevState) => ({
            ...prevState,
            ...data,
        }));

        setFlagSubmit(true);
    };

    const submitData = useCallback(
        async (signalSubmitData) => {
            setLoading(true);

            setFlagSubmit(false);

            await axios(
                {
                    method: "POST",
                    baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
                    url: `${process.env.REACT_APP_API_SETENCUESTARETIRO}`,
                    data,
                    transformRequest: [
                        (data) => {
                            const newData = {
                                strEmailColaborador: strInfoUser.strEmail,
                                objEncuestaRetiro: {
                                    ...data.objEncuestaRetiro,
                                    strNombreEmpresaTrabajar: data.objEncuestaRetiro.strNombreEmpresaTrabajar !== "Otra ¿cuál?" ? data.objEncuestaRetiro.strNombreEmpresaTrabajar : data.objEncuestaRetiro.strOtraNombreEmpresaTrabajar,
                                    strSectorEmpresaTrabajar: data.objEncuestaRetiro.strSectorEmpresaTrabajar !== "Otra ¿cuál?" ? data.objEncuestaRetiro.strSectorEmpresaTrabajar : data.objEncuestaRetiro.strOtraSectorEmpresaTrabajar,
                                    strDondeLlegoOferta: data.objEncuestaRetiro.strDondeLlegoOferta !== "Otra" ? data.objEncuestaRetiro.strDondeLlegoOferta : data.objEncuestaRetiro.strOtraDondeLlegoOferta,
                                    dtFechaRetiro: data.objEncuestaRetiro.dtFechaRetiro ? format(data.objEncuestaRetiro.dtFechaRetiro, "yyyy-MM-dd") : null,
                                },
                            };

                            return JSON.stringify(newData);
                        },
                    ],
                    headers: {
                        token,
                        "Content-Type": "application/json;charset=UTF-8",
                    },
                },
                {
                    cancelToken: signalSubmitData.token,
                }
            )
                .then((res) => {
                    if (res.data.error) {
                        throw new Error(res.data.msg);
                    }

                    toast.success(res.data.msg);
                    setLoading(false);
                    if (isPreview === undefined) {
                        if (setBtEncuestaActiva) setBtEncuestaActiva(false);
                        changePag("info");
                        handlerChangeDataRef.current({ btEncuesta: false });
                        guardaCambiosDeLaInformacion();
                        getData(strInfoUser.strEmail);
                    } else {
                        handleOpenDialog()
                    }
                })


                .catch((error) => {
                    if (!axios.isCancel(error)) {
                        let msg;

                        if (error.response) {
                            msg = error.response.data.msg;
                        } else if (error.request) {
                            msg = error.message;
                        } else {
                            msg = error.message;
                        }

                        console.error(error);
                        setLoading(false);

                        toast.error(msg);
                    }
                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [token, data]
    );

    const getData = useCallback(async (strEmail) => {
        setLoadingGetData(true);
        await refGetInfoEducacion
            .current({
                strEmail
            })
            .then((res) => {
                if (res.data?.error) {
                    throw new Error(res.data.msg);
                }
                const dataCandidato = res?.filter((item) => item.btEncuestaActiva);
                const commonData = {
                    objEncuestaRetiro: {
                        ...dataCandidato[0],
                        dtFechaRetiro: dataCandidato[0]?.dtFechaRetiro ? parseISO(dataCandidato[0].dtFechaRetiro.substring(0, 10)) : null,
                    }
                };

                // Si dataCandidato existe, usa commonData; de lo contrario, usa solo strInfoUser
                if (dataCandidato) {
                    setData(commonData);
                    reset(commonData);
                }
                setLoadingGetData(false);
            })
            .catch((error) => {
                console.log(error)
                setErrors({
                    flag: true,
                    msg: error.message
                        ? error.message
                        : "Ha ocurrido un error inesperado",
                });
                toast.error(error?.message || "Ha ocurrido un error inesperado");
                console.error(error);
                setLoadingGetData(false);
            });
    }, [reset])

    //===============================================================================================================================================
    //========================================== useEffects =========================================================================================
    //===============================================================================================================================================
    useEffect(() => {
        let signalSubmitData = axios.CancelToken.source();

        if (flagSubmit) {

            submitData(signalSubmitData);
        }

        return () => {
            signalSubmitData.cancel("Petición abortada.");
        };
    }, [flagSubmit, submitData]);

    useEffect(() => {
        const signalCancelGetData = axios.CancelToken.source();
        if (strInfoUser?.strEmail) {
            if (isPreview) {
                setData({
                    objEncuestaRetiro: {
                        ...values,
                        dtFechaRetiro: values.dtFechaRetiro ? parseISO(values.dtFechaRetiro.substring(0, 10)) : null,
                    }
                });
                reset({
                    objEncuestaRetiro: {
                        ...values,
                        dtFechaRetiro: values.dtFechaRetiro ? parseISO(values.dtFechaRetiro.substring(0, 10)) : null,
                    }
                });
            } else {
                if (strInfoUser?.strRolApp?.length > 0) {
                    for (let i = 0; i < strInfoUser?.strRolApp?.length; i++) {
                        if (strInfoUser?.strRolApp[i].strNombre === "ADMINISTRADOR") {
                            setAdmin(true);
                        }
                    }
                }
                getData(strInfoUser.strEmail);
            }

        }
        return () => {
            signalCancelGetData.cancel("Abort Peticion");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [strInfoUser, getData]);

    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    const classes = styles(theme);
    if (loadingGetData) {
        return <Loader />;
    }

    if (error.flag) {
        return (
            <Box display="flex" justifyContent="center">
                <Alert severity="warning">
                    <AlertTitle>{error.msg}</AlertTitle>
                    Ha ocurrido un error al momento de cargar los datos de información
                    básica.
                </Alert>
            </Box>
        );
    }

    return (
        <Fragment>
            <Grid
                container
                direction="row"
                spacing={3}
                component="form"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
            >
                <Grid item xs={12} sx={{ paddingTop: "60px" }}>
                    <Paper sx={classes.paper}>
                        {loading ? <LinearProgress sx={classes.linearProgress} /> : null}
                        <Grid
                            container
                            direction="row"
                            spacing={2}
                            style={{ padding: "15px" }}
                        >
                            <Grid item xs={12}>
                                <Typography variant="caption">
                                    Todos los campos marcados con (*) son obligatorios.
                                </Typography>
                            </Grid>

                            {data.objEncuestaRetiro?.strTipoEncuesta === "No voluntario" ?
                                (
                                    <Grid item xs={12}>
                                        <PaperNoVoluntaria
                                            values={data.objEncuestaRetiro}
                                            isTable={isTable}
                                            control={control}
                                            // disabled={!isActive ? false : isPreview ? true : loading}
                                            errors={errors}
                                            setValue={setValue}
                                            setError={setError}
                                            clearErrors={clearErrors}
                                            getValues={getValues}
                                        />
                                    </Grid>
                                ) :
                                null
                            }

                            {data.objEncuestaRetiro?.strTipoEncuesta === "Voluntario" ?
                                (
                                    <Grid item xs={12}>
                                        <PaperVoluntaria
                                            values={data.objEncuestaRetiro}
                                            isTable={isTable}
                                            control={control}
                                            // disabled={!isActive ? false : isPreview ? true : loading}
                                            errors={errors}
                                            setValue={setValue}
                                            setError={setError}
                                            clearErrors={clearErrors}
                                            getValues={getValues}
                                        />
                                    </Grid>
                                ) :
                                null
                            }

                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                        gap: 1,
                                    }}
                                >

                                    <LoadingButton
                                        variant="contained"
                                        type="submit"
                                        loading={loading}
                                    >
                                        {"Guardar"}
                                    </LoadingButton>

                                    {admin && isPreview === null && (
                                        <LoadingButton
                                            variant="contained"
                                            onClick={() => changePag("adicional")}
                                            disabled={loading}
                                        >
                                            {"Siguiente"}
                                        </LoadingButton>
                                    )}

                                    {!admin && isPreview === null && (<LoadingButton
                                        variant="contained"
                                        onClick={() => changePag("infoCorp")}
                                        disabled={loading}
                                    >
                                        {"Anterior"}
                                    </LoadingButton>)}
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Fragment>
    );
}

export default CUEncuestaRetiro;